export enum InputViewModeEnum {
  Input,
  Display,
}
